import { render, staticRenderFns } from "./team-list-new.vue?vue&type=template&id=55665dbd"
import script from "./team-list-new.vue?vue&type=script&lang=js"
export * from "./team-list-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports